import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Events } from 'ionic-angular';
import { Camera, CameraOptions, InAppBrowser } from 'ionic-native';
import 'rxjs/add/operator/map';
import { SessionProvider } from './SessionProvider';
import { LoginProvider } from './LoginProvider';

//let apiUrl = 'http://localhost:63096/api/';

let apiUrl = 'https://ispaapi.steeliran.org/api/';

@Injectable()
export class ServiceProvider {

    constructor(public http: Http, public sessionProvider: SessionProvider,
        public events: Events) { }

    Post(serviceData, serviceUrl, TokenSending: boolean) {
        return new Promise((resolve, reject) => {
            let header = new Headers();
            //header.append('Access-Control-Allow-Origin', '*');
            //header.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT');
            //header.append('Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token');
            //header.append('Accept', 'application/json');
            header.append('Content-Type', 'application/json');
            if (TokenSending) {
                if (this.sessionProvider.getToken() == null) {
                    header.append('token', ' ');
                }
                else {
                    header.append('token', this.sessionProvider.getToken());
                }
            }

            if (serviceData == null) {
                this.http.post(apiUrl + serviceUrl, {}, { headers: header })
                    .subscribe(res => {
                        var result = res.json();
                        this.checkErrorList(result);
                        resolve(result);
                    }, (err) => {
                        reject(err);
                    });
            }
            else {
                this.http.post(apiUrl + serviceUrl, JSON.stringify(serviceData), { headers: header })
                    .subscribe(res => {
                        var result = res.json();
                        this.checkErrorList(result);
                        resolve(result);
                    }, (err) => {
                        reject(err);
                    });
            }
        });
    }

    Get(serviceUrl, TokenSending: boolean) {
        return new Promise((resolve, reject) => {
            let header = new Headers();
            //header.append('Access-Control-Allow-Origin', '*');
            //header.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT');
            //header.append('Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token');
            //header.append('Accept', 'application/json');
            header.append('Content-Type', 'application/json');
            header.append('RoleId', this.sessionProvider.getRole());
            if (TokenSending) {
                if (this.sessionProvider.getToken() == null) {
                    header.append('token', ' ');
                }
                else {
                    header.append('token', this.sessionProvider.getToken());
                }
            }

            this.http.get(apiUrl + serviceUrl, { headers: header })
                .subscribe(res => {
                    var result = res.json();
                    this.checkErrorList(result);
                    if (result.a_responce == 0) {
                        resolve(result.a_Data);
                    }
                    else if (result.a_responce == 2) {
                        this.sessionProvider.clear();
                    }
                    else {
                        reject(result.a_ErrorMessage);
                    }
                }, (err) => {
                    reject(err);
                });
        });
    }

    checkErrorList(serviceResult) {
        let serviceRes: any; serviceRes = serviceResult;

        if (serviceRes.Errors != null) {
            var i; for (i = 0; i < serviceRes.Errors.length; i++) {
                if (serviceRes.Errors[i].Error.Messages[1].Message == 'Invalid security token.') {
                    this.events.publish('user:logout');
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/ServiceProvider.ts